import 'jquery-validation';
import 'jquery-validation-unobtrusive';
import 'inputmask/dist/jquery.inputmask.bundle';
import 'inputmask/dist/inputmask/bindings/inputmask.binding';
import 'jquery-form';
import zenScroll from 'zenscroll';
import swal from 'sweetalert2';
import VueSlider from 'vue-slider-component';
import Vue from 'vue';
import Tracking from './tracking';

const Forms = {
	Init() {
		Forms.Validation();
		Forms.LungCancerEligibilityTool();
		Forms.BMICalculator();
		Forms.AJAXForms();
	},
	Validation() {
		const $validationSummary = $('.validation-summary-errors');
		const $inputValidationError = $('.input-validation-error');

		if ($inputValidationError.length) {
			zenScroll.to($inputValidationError[0]);
			$($inputValidationError)[0].focus();
		} else if ($validationSummary.length) {
			zenScroll.to($validationSummary[0]);
		}

		$($inputValidationError)
			.closest('.form-group')
			.addClass('has-error');
	},
	AJAXForms() {
		Forms.AJAXFormsInit('.form-ajax--default', {
			onSuccess: (responseText, statusText, xhr, $form) => {
				Forms.ShowModalResult(responseText, statusText, xhr, $form);
				Tracking.TrackAdWordsConversion(
					`${$('body').data('google-ads-conversionid')}/${$('body').data('google-ads-conversionlabel')}`
				);
			},
			onError: (responseText, statusText, xhr, $form) => {
				Forms.ShowModalResult(responseText, statusText, xhr, $form);
			},
			onMessages: (responseText, statusText, xhr, $form) => {
				Forms.ShowModalMessages(responseText, statusText, xhr, $form);
			}
		});

		Forms.AJAXFormsInit('.form-ajax--inpage', {
			onSuccess: (responseText, statusText, xhr, $form) => {
				Forms.AddResultToPage(responseText, statusText, xhr, $form);
			},
			onError: (responseText, statusText, xhr, $form) => {
				Forms.AddResultToPage(responseText, statusText, xhr, $form);
			},
			resetForm: false
		});
	},
	AJAXFormsInit(selector, options) {
		const defaults = {
			onSuccess: null,
			onError: null,
			resetForm: true
		};

		const opts = $.extend({}, defaults, options);

		$(selector).ajaxForm({
			beforeSubmit: (arr, $form, _options) => {
				try {
					Tracking.TrackPixel($form.data('track-pixel'));
				} catch (exc) {
					// nothing to do
				}
			},
			beforeSerialize: () => {
				Forms.DisableForms();
			},
			success: (responseText, statusText, xhr, $form) => {
				switch (responseText.Status.toLowerCase()) {
					case 'complete':
						if (opts.onSuccess != null) {
							opts.onSuccess(responseText, statusText, xhr, $form);
						}
						break;
					case 'message':
						opts.resetForm = false;
						if (opts.onMessages != null) {
							opts.onMessages(responseText, statusText, xhr, $form);
						}
						break;
					default:
						if (opts.onError != null) {
							opts.onError(responseText, statusText, xhr, $form);
						}
						break;
				}
				Forms.EnableForms();
				if (opts.resetForm) {
					$form[0].reset();
				}
			},
			error: (responseText, statusText, xhr, $form) => {
				if (opts.onError != null) {
					opts.onError(responseText, statusText, xhr, $form);
				}
				Forms.EnableForms();
			}
		});
	},
	ShowModalResult(responseText, statusText, xhr, $form) {
		const responseJSON = responseText;
		Tracking.TrackPageView(responseJSON.Route);
		$('<div />').load(`${responseJSON.Route} #form-result`, function buildAlert() {
			swal.fire({
				html: $(this).html(),
				showCloseButton: true,
				// type: responseJSON.Type,
				buttonsStyling: false,
				icon: responseJSON.Status === 'Complete' ? 'success' : 'error',
				confirmButtonText: $form.data('swal-confirm-button-text'),
				customClass: {
					confirmButton: 'btn btn-indigo'
				}
			});
		});
	},
	ShowModalMessages(responseText, statusText, xhr, $form) {
		swal.fire({
			html: `<ul class="mt-2 text-left">${responseText.Errors[0]
				.map(err => `<li class="mb-2">${err.ErrorMessage}</li>`)
				.join('')}</ul>`,
			showCloseButton: true,
			buttonsStyling: false,
			icon: 'warning',
			confirmButtonText: $form.data('swal-confirm-button-text'),
			customClass: {
				confirmButton: 'btn btn-indigo'
			}
		});
	},
	AddResultToPage(responseText, statusText, xhr, $form) {
		const responseJSON = responseText;
		Tracking.TrackPageView(responseJSON.Route);

		const $target = $form.data('target');
		$($target).load(`${responseJSON.Route} #form-result`, () => {
			$($target).addClass('js--is-active');
			zenScroll.to(document.querySelector($target));

			const $targetShow = $form.data('target-show');
			if ($targetShow != null) {
				$($targetShow).removeClass('js--is-inactive');
			}
		});
	},
	DisableForms() {
		$('.btn')
			.attr('disabled', 'disabled')
			.addClass('btn-disabled');
	},
	EnableForms() {
		$('.btn')
			.removeAttr('disabled')
			.removeClass('btn-disabled');
	},
	LungCancerEligibilityTool() {
		/* eslint-disable */
		if ($('#form-lung-cancer-eligibility-tool').length) {
			const eligibilityTool = new Vue({
				el: '#form-lung-cancer-eligibility-tool',
				data: {
					questionsCount: $('.list--questions .list--item').length,
					currentQuestion: 1,
					yearsSmoked: null,
					cigsPerDay: null,
					packsPerDay: null,
					packYears: null,
				},
				methods: {
					reset() {
						this.currentQuestion = 1;
						this.yearsSmoked = null,
						this.cigsPerDay = null,
						this.packsPerDay = null,
						this.packYears = null
					},
					next() {
						this.currentQuestion += 1;
					},
					calculate() {
						if (this.yearsSmoked != null && this.cigsPerDay != null) {
							this.currentQuestion = 0;
							this.packsPerDay = this.cigsPerDay / 20;
							this.packYears = this.yearsSmoked * this.packsPerDay;

							if (this.packYears >= 30) {
								GA.TrackPageView(`${document.location.href}#eligible`);
							} else {
								GA.TrackPageView(`${document.location.href}#not-eligible`);
							}
						}
					},
					end() {
						this.currentQuestion = 0;
					}
				}
			});
		}
		/* eslint-enable */
	},
	BMICalculator() {
		/* eslint-disable */
		if ($('#bmi_calculator').length) {
			const bmiCalculator = new Vue({
				el: '#bmi_calculator',
				components: {
					VueSlider
				},
				data: {
					bmi: null,
					bmiCategory: 'default',
					heightOptions: {
						dotSize: 44,
						height: null,
						tooltipFormatter: val => `${Math.floor(val / 12)}' ${val - ((Math.floor(val / 12)) * 12)}"`,
						value: 68
					},
					weightOptions: {
						dotSize: 44,
						tooltipFormatter: '{value}lbs.',
						value: 150
					}
				},
				methods: {
					calculateBMI() {
						let height = this.$refs.sliderHeight.getValue();
						let weight = this.$refs.sliderWeight.getValue();
						let bmi = Math.floor((weight / (height * height)) * 703);
						this.bmi = bmi
						this.setCategory(bmi);
					},
					setCategory(bmi) {
						if (bmi < 18.5) {
							return this.bmiCategory = 'underweight';
						} else if (bmi < 25) {
							return this.bmiCategory = 'normal';
						} else if (bmi < 30) {
							return this.bmiCategory = 'overweight';
						} else {
							return this.bmiCategory = 'obese';
						}
					}
				},
			});
		}
		/* eslint-enable */
	}
	// RangeSliders() {
	// 	/* eslint-disable */
	// 	const elements = document.querySelectorAll('.form-control-range-slider');

	// 	elements.forEach(element => {
	// 		const orientation = element.getAttribute('data-orientation');
	// 		const units = element.getAttribute('data-units');
	// 		const val = element.getAttribute('value');

	// 		rangeSlider.create(element, {
	// 			polyfill: true,
	// 			vertical: orientation === 'vertical' ? true : false,
	// 			onInit: function () {
	// 				element.nextElementSibling.querySelector('.rangeSlider__handle').innerHTML = Forms.GetHandle(val, units);
	// 			},
	// 			onSlide: function (position, value) {
	// 				element.nextElementSibling.querySelector('.rangeSlider__handle').innerHTML = Forms.GetHandle(value, units);
	// 				// TODO: Calculate BMI - need to call some function here, perhaps defined via data-attribute on the slider
	// 			},
	// 			onSlideEnd: function (position, value) {
	// 				// TODO: Show/hide stuff
	// 			}
	// 		});
	// 	});
	// 	/* eslint-enable */
	// },
	// GetHandle(value, units) {
	// 	/* eslint-disable */
	// 	let displayUnits = '';

	// 	if (units === 'in.') {
	// 		const feet = Math.floor(value / 12);
	// 		const inches = value - (feet * 12);
	// 		value = `<span class='range-value_value'>${feet}<sup class='range-value_units'>'</sup></span><span class='range-value_value'>${inches}<sup class='range-value_units'>\"</sup>`;
	// 		//value = feet + "<sup class='range-value_units'>'</sup> " + inches + "<sup class='range-value_units'>\"</sup>";
	// 		// Otherwise, display units are the indicated units
	// 	} else {
	// 		displayUnits = units;
	// 	}
	// 	return `<span class='range-value'>${value}<sup class='range-value_units'>${displayUnits}</sup></span>`
	// 	/* eslint-enable */
	// }
};

export default Forms;
